export const hoursToMinutes = (hours: number): number => {
  return hours * 60
}

export const translateTimezone = (timezone: string): string => {
  switch (timezone) {
    case 'America/Sao_Paulo':
      return 'Brasília'
    case 'America/Manaus':
      return 'Amazonas'
    case 'America/Noronha':
      return 'Noronha'
    case 'America/Rio_Branco':
      return 'Acre'
    default:
      return timezone
  }
}
